import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "privacy" };
const _hoisted_2 = { class: "privacy__inner" };
const _hoisted_3 = { class: "privacy__label" };
const _hoisted_4 = { class: "privacy__title" };
const _hoisted_5 = { class: "privacy__updated" };
const _hoisted_6 = { class: "privacy__intro" };
const _hoisted_7 = { class: "privacy__heading" };
const _hoisted_8 = { class: "privacy__body" };
const _hoisted_9 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_reveal = _resolveDirective("reveal");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('privacy.label')), 1),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('privacy.title')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('privacy.updated')), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('privacy.intro')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, i) => {
                return (_openBlock(), _createElementBlock("section", {
                    key: i,
                    class: "privacy__section"
                }, [
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(section.heading), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(section.body), 1)
                ]));
            }), 128)),
            _createElementVNode("a", {
                href: `mailto:${_ctx.$t('contact.email')}`,
                class: "privacy__email"
            }, _toDisplayString(_ctx.$t('contact.email')), 9, _hoisted_9)
        ])), [
            [_directive_reveal]
        ])
    ]));
}
